import AutoShutdown from "./AutoShutdownSettingsRoot.vue"

export default AutoShutdown
